import { useContext, useEffect, useState, useRef } from 'react'
import axios from 'axios'
import axio from 'axios'
import Modal from 'react-modal'
import { useForm } from 'react-hook-form'
import Loading from '../../components/Loading'
import { projectContext, loadingContext, urlValue, unfolder, onImportExcelAsync, closeModalVw, openModalVw, openAlert, downloadFile, encrypter } from '../../lib'
import '../../styles/settings.scss'
import '../../styles/settingsOptions.scss'
import { customModal } from '../../styles/customModal'
import TitleBar from "../../components/TitleBar";
import '../../styles/styles.css'
import ModalVw, { ModalBody, ModalContent, ModalHeader } from '../../components/common/ModalVw'
import CheckBox2 from '../../components/CheckBox2'
import { Tooltip, } from 'react-tooltip'
import 'react-tooltip/dist/react-tooltip.css'
import { SettingsOptionsGenAI } from '../../components/ProjectGenAI/SettingsOptionsGenAI'
import SideBarGenAI from '../../components/ProjectGenAI/SideBarGenAI'
import { Alerts } from '../../components/common/Alerts'

export default function SettingsGenAI() {
  const [selectedProject, setSelectedProject] = useContext(projectContext)
  const [clients, setClients] = useState([])
  const [isModalOpen, setIsModalOpen] = useState({
    delete: false,
    new: false,
    edit: false,
    delete_many: false
  })
  const [refresh, setRefresh] = useState(false)
  const [selectedClient, setSelectedClient] = useState()
  const ref = useRef(null)
  const [search, setSearch] = useState('')
  const [loading, setLoading] = useContext(loadingContext)
  const [usersDelete, setUsersDelete] = useState([]);
  const [alert, setAlert] = useState({ title: '', visible: false })
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm()

  useEffect(() => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/client-project/${selectedProject.id}`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        setClients(response.data.clients)
        setLoading(false)
      })
      .catch(function (error) {
        setLoading(false)
      })
  }, [refresh])

  function openModal(modal, client) {
    setValue('id', null)
    setValue('name', null)
    if (modal === 'new') {
      setIsModalOpen({ ...isModalOpen, new: true })
    } else {
      setSelectedClient(client)
      if (modal === 'edit') {
        // setIsModalOpen({ ...isModalOpen, edit: true })
        openModalVw("#edituser-md", () => setIsModalOpen({ ...isModalOpen, edit: true }))
        setValue('id', client.ccms_id)
      } else {
        // setIsModalOpen({ ...isModalOpen, delete: true })
        openModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: true }))
      }
    }
  }

  const onSubmitDelete = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    setLoading(true)
    axios({
      method: 'get',
      url: `${urlValue}/studio/client-project`,
      headers: {
        'access-token': token,
      },
    })
      .then(function (response) {
        const id = response.data.filter(value => {
          if (
            value.project_id === selectedProject.id &&
            value.client_id === selectedClient.id
          ) {
            return value
          }
        })[0].id
        axios({
          method: 'delete',
          url: `${urlValue}/studio/client-project/${id}`,
          headers: {
            'access-token': token,
          },
        })
          .then(function (response) {
            setLoading(false)
            setIsModalOpen({ ...isModalOpen, delete: false })
            setRefresh(!refresh)
          })
          .catch(function (error) {
            setLoading(false)
            setIsModalOpen({ ...isModalOpen, delete: false })
            setRefresh(!refresh)
          })
      })
      .catch(function (error) {
        setLoading(false)
      })
  }

  const onSubmitNew = data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    
    const data2 = JSON.stringify({
      ccms_id: data.id,
      ccms_name: data.name,
      max_multichat: 5,
      multiple: false,
      project: selectedProject.id
    })
    const encry = encrypter(data2, 'IANestingKey')
    
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client`,
      headers: {
        user: id,
        'access-token': token,
      },
      data: {"usuario": encry},
    })
      .then(function (response) {
        openAlert('#alert-ac', () => { setAlert({ title: 'Account have been create properly!', visible: true }) }, 4000,
          () => { setAlert({ ...alert, visible: false }) });
        postClientProject(response.data.client.id, true)
      })
      .catch(function (error) {
        getIdClientByCcmsId(data.id).then(id => postClientProject(id, true))
      })
  }

  const onSubmitEdit = async data => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    setLoading(true)
    axios({
      method: 'put',
      url: `${urlValue}/studio/client/${selectedClient.id}`,
      headers: {
        user: id,
        'access-token': token,
      },
      data: {
        ccms_id: data.id,
        ccms_name: data.name,
      },
    })
      .then(function (response) {
        setLoading(false)
        setIsModalOpen({ ...isModalOpen, edit: false })
        setRefresh(!refresh)
      })
      .catch(function (error) {
        setLoading(false)
        setIsModalOpen({ ...isModalOpen, edit: false })
      })
  }

  const postClientProject = (clientId, load) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    axios({
      method: 'post',
      url: `${urlValue}/studio/client-project`,
      headers: {
        user: id,
        'access-token': token,
      },
      data: {
        project_id: selectedProject.id,
        client_id: clientId,
      },
    })
      .then(function (response) {
        if (load) {
          setIsModalOpen({ ...isModalOpen, new: false })
          setLoading(false)
          setRefresh(!refresh)
        }

      })
      .catch(function (error) {
        if (load) {
          setIsModalOpen({ ...isModalOpen, new: false })
          setLoading(false)
        }
      })
  }

  const getIdClientByCcmsId = async (ccmsId, load) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
    return await axios({
      method: 'get',
      url: `${urlValue}/studio/client`,
      headers: {
        user: id,
        'access-token': token,
      },
    })
      .then(function (response) {
        if (load) setLoading(false)
        return response.data.filter(value => {
          if (value.ccms_id === ccmsId) {
            return value
          }
        })[0].id
      })
      .catch(function (error) {
        if (load) setLoading(false)
      })
  }

  const submitNew = () => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    const ccms_id = document.querySelector("#ccms_id").value;
    const ccms_name = document.querySelector("#ccms_name").value;
    setLoading(true)
    axios({
      method: 'post',
      url: `${urlValue}/studio/client`,
      headers: {
        'access-token': token,
      },
      data: {
        ccms_id: ccms_id,
        ccms_name: ccms_name
      },
    })
      .then(function (response) {
        postClientProject(response.data.client.id, true)
      })
      .catch(function (error) {
        getIdClientByCcmsId(ccms_id, true).then(id => postClientProject(id, true))
      })
  }



  // const [UsersExcel, setUsersExcel] = useState([]);
  const [loadingUpload, setLoadingUpload] = useState(false)

  const uploadMaxive = async (UsersExcel) => {

    if (!loadingUpload && UsersExcel.length > 0 && UsersExcel.length <= 101) {

      setLoadingUpload(true)
      setTimeout(async () => {
        setLoading(true)
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;

        for (var i = 0; i < UsersExcel.length; i++) {
          const data = {
            ccms_id: UsersExcel[i].CCMS_ID.toString().trim(),
            ccms_name: UsersExcel[i].CCMS_NAME.toString().trim(),
            max_multichat: 5,
            project: selectedProject.id,
            multiple: true
          }

          const encry = encrypter(data, 'IANestingKey')

          try {
            const rest = await axios.post(`${urlValue}/studio/client`, {"usuario": encry}, {
              headers: {
                'access-token': token
              }
            });
            if (rest.status === 200) {
              const restCp = await axios.post(`${urlValue}/studio/client-project`, {
                project_id: selectedProject.id,
                client_id: rest.data.client.id,
              },
                { headers: { user: id, 'access-token': token } })


            } else {
              await getIdClientByCcmsId(UsersExcel[i].CCMS_ID.toString().trim(), false).then(id => postClientProject(id, false))
            }
          } catch (error) {
            await getIdClientByCcmsId(UsersExcel[i].CCMS_ID.toString().trim(), false).then(id => postClientProject(id, false))
          }


        }

        window.location.reload();
      }, 1000)

    } else {
      alert("Cannot insert more than 100 lines")

    }

  }
  const prepareExcel = async (file) => {
    const DatosExcel = await onImportExcelAsync(file);

    uploadMaxive(DatosExcel);

  }


  const selectAll = (e) => {
    if (e.target.checked) {
      document.querySelectorAll("#users-all input[type='checkbox']").forEach((item) => {
        item.checked = true;
      })
    } else {
      document.querySelectorAll("#users-all input[type='checkbox']").forEach((item) => {
        item.checked = false;
      })
    }
  }

  const deleteMultiple = async () => {
    try {
      if (usersDelete.length > 0) {
        let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id
        let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token
        let result;
        for (let i = 0; i < usersDelete.length; i++) {
          const resp = await axios({
            method: 'get',
            url: `${urlValue}/studio/client-project`,
            headers: { 'access-token': token, },
          })
          const id = resp?.data.filter(value => {
            if (
              value.project_id === selectedProject.id &&
              value.client_id === usersDelete[i].id
            ) {
              return value
            }
          })[0]?.id
          await axios({
            method: 'delete',
            url: `${urlValue}/studio/client-project/${id}`,
            headers: {
              'access-token': token,
            },
          })
        }
      }
    } catch (error) {
      console.log(error)
      // setModalDelete(false)
    } finally {
      closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))
      // setModalDelete(false)
      window.location.reload();
    }
  }

  const selectForDelete = (e, item) => {
    if (e.target.checked) {
      setUsersDelete([...usersDelete, item])
    } else {
      setUsersDelete(usersDelete.filter(x => x.id !== item.id));
    }
  }


  return (
    <>
      <section className="container-settings general-container" id="container">
        <SideBarGenAI active={'Settings'} />
        <div className="container">
          <div className="con_title_bar">
            <TitleBar />
          </div>
          <div className="container-info w-100 d-flex flex-row flex-wrap justify-space-between">
            <div className="d-flex flex-row align-items-center flex-wrap justify-space-between w-100">
              <div className="title d-flex flex-row align-items-center ml-2" style={{ whiteSpace: "nowrap" }}>
                <div>
                  <h2>{selectedProject.name}</h2>
                </div>
                <div className="p-1 separator">-</div>
                <div>
                  <h1>Settings</h1>
                </div>
              </div>
            </div>

            <div className="container-edit settings-c" style={{ height: '60vh', }}>

              <SettingsOptionsGenAI />

            </div>

            <div className="body pt-1 account-container account-c" style={{ backgroundColor: '#F9F9F9', borderRadius: 25 }}>
              <h2 className="pl-3" style={{ color: '#0B5FA3', fontSize: 18 }}>Account Management</h2>


              <div className="pl-3 d-flex flex-row align-items-center justify-space-between">
                <div className=" head w-100 ">

                  <div className="search " >
                    <input
                      type="text"
                      placeholder="Search User"
                      onChange={event => {
                        setSearch(event.target.value)
                      }}
                      style={{width:'80%', fontSize:'14px'}}
                    />
                    <img src="/icons/search.svg" />
                  </div>
                  <div className="flex flex-1 items-center  jsutify-end">
                    <div id="adduser-btn" className="ml-2 btn-top btn-top-new newProject" onClick={() => openModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: true }))} style={{ backgroundColor: '#0038A8' }}>
                      <span className='' style={{ color: 'white !important' }}>Add User</span>
                      
                      <Tooltip  anchorSelect="#adduser-btn" content={`Add new user to the project`} place="top" />
                    </div>
                    <div onClick={() => openModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: true }))} className="ml-2 btn-top btn-top-delete newProject" style={{ backgroundColor: '#0038A8' }}>
                      <span className='' style={{ color: 'white !important' }}>Delete</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="titles mt-3 d-flex flex-row w-100" style={{ justifyContent: 'space-between' }}>
                <div className="name">
                  <div style={{ color: "#0087FF" }}>CCMS NAME</div>
                </div>
                <div className="id">
                  <div style={{ color: "#0087FF" }}>CCMS ID</div>
                </div>
              </div>
              <div className="elements" ref={ref} id="users-all">
                {clients
                  .filter(value => {
                    if (search == '') {
                      return value
                    } else if (
                      value?.ccms_id?.toLowerCase()?.includes(search.toLowerCase()) ||
                      value?.ccms_name?.toLowerCase()?.includes(search.toLowerCase())
                    ) {
                      return value
                    }
                  })
                  .map((client, index) => (
                    <div className="element" key={index}>
                      <div className="client">
                        <div className="name">
                          <CheckBox2 onChange={(e) => selectForDelete(e, client)} default={false} id={`${client.ccms_id}`} text="" />
                          <h3 >{client.ccms_name}</h3>
                        </div>
                        <div className="id">
                          <h3>{client.ccms_id}</h3>
                        </div>
                      </div>
                      <div className="more">
                        <img
                          src="/icons/edit.png"
                          alt="edit"
                          onClick={() => openModal('edit', client)}
                        />
                        <img
                          src="/icons/trash.png"
                          alt="trash"
                          onClick={() => openModal('delete', client)}
                        />
                      </div>
                    </div>
                  ))}
              </div>
              <div className="count">
                {/* <h4>1 - {ref.current ? ref.current.children.length : 1}</h4> */}
              </div>
            </div>

          </div>
          {alert.visible && <Alerts id="alert-ac" title={alert.title} />}
        </div>
      </section>


      {isModalOpen.delete &&
        <ModalVw id="deleteuser-md" visible={isModalOpen.delete}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))} />
            <ModalBody clases={``} >


              {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className='modal-c'>
                <img src="/icons/alert.png" alt="" />
                <h1>You are about to delete a user.</h1>
                <h1>Are you sure you want to proceed?</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deleteuser-md", () => setIsModalOpen({ ...isModalOpen, delete: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    Cancel
                  </button>
                  <button onClick={onSubmitDelete} className="accept">
                    Yes
                  </button>
                </div>
              </div>
              {/* </Modal> */}

            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.delete_many &&
        <ModalVw id="deletemany-md" visible={isModalOpen.delete_many}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))} />
            <ModalBody clases={``} >


              {/* <Modal isOpen={isModalOpen.delete} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className='modal-c'>
                <img src="/icons/alert.png" alt="" />
                <h1>You are about to delete many user.</h1>
                <h1>Are you sure you want to proceed?</h1>
                <div className="buttons-modal">
                  <button
                    onClick={() => closeModalVw("#deletemany-md", () => setIsModalOpen({ ...isModalOpen, delete_many: false }))}
                    className="cancel btn-modal-cancel"
                  >
                    Cancel
                  </button>
                  <button type='button' onClick={() => deleteMultiple()} className="accept">
                    Yes
                  </button>
                </div>
              </div>
              {/* </Modal> */}

            </ModalBody>
          </ModalContent>
        </ModalVw>}

      {isModalOpen.new &&
        <ModalVw id="adduser-md" visible={isModalOpen.new}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))} />
            <ModalBody clases={``} >
              <div id="container-modal" className="addUser-modal">
                <h2>ADD USER CLIENT FORM</h2>
                <form onSubmit={handleSubmit(onSubmitNew)}>
                  <div className="inputs-modal">
                    <div className="input">
                      <span>CCMS ID:</span>
                      <input
                        id="ccms_id" placeholder='Enter the specific user ID'
                        {...register('id', { required: true, pattern: /^\d+$/ })}
                        type="text"
                      />
                    </div>
                    <div className="input">
                      <span>CCMS NAME:</span>
                      <input id="ccms_name" placeholder='Enter the specific user CCMS'
                       {...register('name', { required: true })} type="text" />
                    </div>
                  </div>
                  <div className="flex items-center justify-end flex-wrap w-full">
                    {/* <div className="upload-excel trans">
                      <img src="/icons/excel.svg" alt="" style={{ width: 30, marginBottom: 0 }} /><label> Upload Excel</label>
                      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />
                    </div> */}

                    <div className="upload-excel btn-excel upload-btn trans">

                      {loadingUpload ? <Loading /> : <>
                        <img src="/icons/excel.svg" alt="newAns" style={{ width: 19, marginBottom: 0 }} />
                        <label> Upload Excel</label>

                      </>}

                      <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />
                    </div>
                    <div className="input " style={{ marginLeft: 10, }}>
                      <div style={{cursor: 'pointer'}}  onClick={()=>{downloadFile("FormatUsers.xlsx")}} className="a-download trans btn-excel"     >Download Template</div>
                    </div>

                    {/* <div className="input">
                      <a className="a-download trans" href={"/excel/FormatUsers.xlsx"} download >Download Template</a>
                    </div>
                    <div className="input">
                      <div onClick={() => { uploadMaxive() }} className="a-download upload-btn trans"   >
                        <div className='btn-loanding'>
                          {loadingUpload ? <Loading /> : <div>Upload</div>}
                        </div>

                      </div>
                    </div> */}
                  </div>
                  <div className="buttons-modal">
                    <button
                      onClick={() => closeModalVw("#adduser-md", () => setIsModalOpen({ ...isModalOpen, new: false }))}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      Cancel
                    </button>
                    <button className="accept btn-bottom btn-bottom-create" type="submit" >
                      Yes
                    </button>
                  </div>
                </form>
              </div>
            </ModalBody>
          </ModalContent>
        </ModalVw>}
      {/* <Modal  isOpen={isModalOpen.new} style={customModal} ariaHideApp={false}>
        <div id="container-modal" className="addUser-modal">
          <h2>ADD USER CLIENT FORM</h2>
          <form onSubmit={handleSubmit(onSubmitNew)}>
            <div className="inputs-modal">
              <div className="input">
                <span>CCMS ID:</span>
                <input
                  id="ccms_id"
                  {...register('id', { required: true, pattern: /^\d+$/ })}
                  type="text"
                />
              </div>
              <div className="input">
                <span>CCMS NAME:</span>
                <input id="ccms_name"  {...register('name', { required: true })} type="text" />
              </div>
            </div>
            <div className="flex items-center justify-end flex-wrap w-full">
              <div className="upload-excel trans">
                <img src="/icons/excel.svg" alt="" style={{ width: 30, marginBottom: 0 }} /><label> Upload Excel</label>
                <input type='file' accept='.xlsx, .xls' onChange={prepareExcel} />
              </div>
              <div className="input">
                <a className="a-download trans" href={"/excel/FormatUsers.xlsx"} download >Download Template</a>
              </div>
              <div className="input">
                <div onClick={() => { uploadMaxive() }} className="a-download upload-btn trans"   >
                  <div className='btn-loanding'>
                    {loadingUpload ? <Loading /> : <div>Upload</div>}
                  </div>

                </div>
              </div>
            </div>
            <div className="buttons-modal">
              <button
                onClick={() => setIsModalOpen({ ...isModalOpen, new: false })}
                type="button"
                className="cancel btn-bottom btn-bottom-cancel"
              >
                Cancel
              </button>
              <button className="accept btn-bottom btn-bottom-create" type="submit" >
                Yes
              </button>
            </div>
          </form>
        </div>
      </Modal> */}



      {isModalOpen.edit &&
        <ModalVw id="edituser-md" visible={isModalOpen.edit}  >
          <ModalContent clases={`sm:w-[80%] md:w-[80%] lg:w-[70%] xl:w-[55%] 2xl:w-1/3  w-[27%]  bg-white`}>
            <ModalHeader title="" onClose={() => closeModalVw("#edituser-md", () => setIsModalOpen({ ...isModalOpen, edit: false }))} />
            <ModalBody clases={``} >
              {/* <Modal isOpen={isModalOpen.edit} style={customModal} ariaHideApp={false}> */}
              <div id="container-modal" className="addUser-modal">
                <h2>EDIT USER CLIENT</h2>
                <form onSubmit={handleSubmit(onSubmitEdit)}>
                  <div className="inputs-modal">
                    <div className="input">
                      <span>CCMS ID:</span>
                      <input
                        placeholder='Enter the specific user ID'
                        {...register('id', { required: true, pattern: /^\d+$/ })}
                        type="text"
                        disabled={true}
                      />
                    </div>
                    <div className="input">
                      <span>CCMS NAME:</span>
                      <input placeholder='Enter the specific user CCMS'
                        {...register('name', { required: true })} type="text" />
                    </div>
                  </div>
                  <div className="buttons-modal">
                    <button
                      onClick={() => setIsModalOpen({ ...isModalOpen, edit: false })}
                      type="button"
                      className="cancel btn-bottom btn-bottom-cancel"
                    >
                      Cancel
                    </button>
                    <button onClick={() => submitNew()} className="btn-bottom btn-bottom-create accept" type="submit">
                      Confirm
                    </button>
                  </div>
                </form>
              </div>
              {/* </Modal> */}
            </ModalBody>
          </ModalContent>
        </ModalVw>}
    </>
  )
}
